import Styled from "styled-components";

export default Styled.hr`
  width: 100%;
  color: ${props => props.theme.palette.primary["900"]};
  margin: ${props => props.margin || 8}px 0;
`;
